<template lang="pug">
.select-vendor-input
  el-row(style="margin-top: 0")
    el-col(
      v-if="index === 0"
      :class="{ required: title !== '' }"
      :span="4"
    ) {{ $t(title) }}
    el-col(:span="20" :offset="(index !== 0 || title === '') ? 4 : 0" style="text-align:left")
      el-select(
        v-model="item.is_storage"
        style="width: 168px;margin-right: 15px"
        @change="handleChangeRoster()"
      )
        el-option(
          v-for="(item,index) in rosterOptions"
          :key="index"
          :label="item.label"
          :value="item.value"
        )

      el-select(
        v-model="item.struct_group_id"
        filterable
        :placeholder="$t('请选择供应商')"
        style="width:225px"
        @focus="getVendorList(item.is_storage)"
      )
        el-option(
          v-for="(item,index) in vendorOptions"
          :key="index"
          :label="item.struct_group_name"
          :value="item.struct_group_id"
          :disabled="shouldDisabledVendor(item)"
        )
      i.el-icon-delete(
        v-if="index !== 0"
        style="margin-left: 8px"
        @click="selectedVendors.splice(index, 1)"
      )
</template>

<script>
import axios from 'axios'

export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default () {
        return {
          is_storage: 1,
          struct_group_name: '',
          struct_group_id: null
        }
      }
    },
    title: {
      type: String,
      default () {
        return ''
      }
    },
    categorys: {
      type: Array,
      default () {
        return []
      }
    },
    selectedVendors: {
      type: Array,
      default () {
        return [{
          is_storage: 1,
          struct_group_name: '',
          struct_group_id: null
        }]
      }
    },
    disabledVendorList: {
      type: Array,
      default () {
        return []
      }
    },
    showUnauthorised: {
      type: Boolean,
      default () {
        return false
      }
    },
    totalVendorOptions: {
      type: Array,
      default () {
        return []
      }
    },
    allRanges: {
      type: Boolean,
      default () {
        return false
      }
    },
    ignoreEvents: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      vendorOptions: []
    }
  },
  async mounted () {
    this.vendorOptions = this.totalVendorOptions != null ? this.totalVendorOptions : await this.getVendorList(this.item.is_storage)
  },
  computed: {
    rosterOptions () {
      let options = [
        {
          value: 1,
          label: this.$t('核心')
        },
        {
          value: 0,
          label: this.$t('非核心')
        },
        {
          value: 3,
          label: this.$t('非总库')
        }
      ]
      if (this.showUnauthorised) {
        options.push({value: 2, label: this.$t('待入库')})
      }
      return options
    },
    campaignId () {
      return this.$store.state.campaign.id
    }
  },
  methods: {
    async getVendorList (isStorage) {
      let params = {
        filter_condition: isStorage,
        category_id: this.categorys.map(i => i.category_id).join(',')
      }
      let url = '/admin/struct/getVendorList'
      let hasEvents = this.categorys.some(category => { return category.category_id === 13 })
      if (hasEvents && !this.allRanges && !this.ignoreEvents) {
        url = '/management/campaign/v3/getEventCampaignVendorList'
        params = {
          campaign_id: this.campaignId,
          filter_condition: isStorage
        }
      }
      try {
        this.vendorOptions = await axios.get(url, {params})
      } catch (err) {
        throw new Error(err)
      }
    },
    handleChangeRoster () {
      this.item.struct_group_name = ''
      this.item.struct_group_id = null
    },
    shouldDisabledVendor (vendor) {
      return this.disabledVendorList.length === 0 ? false : (this.disabledVendorList.some(i => i.vendor_id === vendor.struct_group_id) || this.disabledVendorList.some(i => i.struct_group_id === vendor.struct_group_id))
    }
  }
}
</script>

<style lang="stylus">

</style>
